import {z} from 'zod';

export const USER_TYPE_REGULAR = 'regular';
export const USER_TYPE_LIGHT = 'light';
export const USER_TYPE_COMPANY = 'company';

export const SCOUT_STATUS_UNREAD = 'unread';
export const SCOUT_STATUS_READ = 'read';
export const SCOUT_STATUS_ACCEPTED = 'accepted';
export const SCOUT_STATUS_REJECT = 'reject';

export const SCOUT_STATUS_ALL = 'all';
export const SCOUT_STATUS_UNACCEPTED = 'unaccepted';

export const SCOUT_CHAT_STATUS_NONE = 'none';
export const SCOUT_CHAT_STATUS_DONE = 'done';
export const SCOUT_CHAT_STATUS_READ = 'read';
export const SCOUT_CHAT_STATUS_NEED = 'need';

export const SCOUT_SORT_NEW = 'new';
export const SCOUT_SORT_DEADLINE = 'deadline';

export const MESSAGE_TYPE_TEXT = 'text';

export const ScoutStatus = {
  unread: SCOUT_STATUS_UNREAD,
  read: SCOUT_STATUS_READ,
  accepted: SCOUT_STATUS_ACCEPTED,
  reject: SCOUT_STATUS_REJECT,
};

export const ScoutChatStatus = {
  none: SCOUT_CHAT_STATUS_NONE,
  done: SCOUT_CHAT_STATUS_DONE,
  read: SCOUT_CHAT_STATUS_READ,
  need: SCOUT_CHAT_STATUS_NEED,
};

export const ScoutSort = {
  new: SCOUT_SORT_NEW,
  deadline: SCOUT_SORT_DEADLINE,
} as const;

export const ScoutStatusForFilter = {
  all: SCOUT_STATUS_ALL,
  unaccepted: SCOUT_STATUS_UNACCEPTED,
  ...ScoutStatus,
} as const;

export const MessageTypes = {
  text: MESSAGE_TYPE_TEXT,
} as const;

export const UserTypes = {
  regular: USER_TYPE_REGULAR,
  light: USER_TYPE_LIGHT,
  company: USER_TYPE_COMPANY,
} as const;

export const ScoutSortEnum = z.nativeEnum(ScoutSort);
export const ScoutStatusEnum = z.nativeEnum(ScoutStatus);
export const ScoutChatStatusEnum = z.nativeEnum(ScoutChatStatus);
export const UserTypesEnum = z.nativeEnum(UserTypes);
export const MessageTypesEnum = z.nativeEnum(MessageTypes);
